import { Entity } from "game-common/models"
import { AnimationPoseView, sampleAnimationPose } from "game-common/animation_pose"
import { radians_to_cardinal_dir } from "game-common/util"

export interface BodyAnimationPose {
    action: string
    progress: number
    frame?: number
}

/** Any body can hold or release a pose. No NPC, weapon, target or campaign assumptions. */
export class AnimationPoseDriver {
    private view?: AnimationPoseView
    private receivedAt = 0
    update = (entity: Entity, now: number): BodyAnimationPose | undefined => {
        // A flourish moves the body, not its frames (BodyFlourish): the sheet carries on as it was.
        if (entity.hp <= 0 || entity.isDead() || !entity.animationPose || entity.animationPose.flourish) { this.view = undefined; return undefined }
        if (entity.animationPose !== this.view) this.receivedAt = now
        this.view = entity.animationPose
        const sampled = sampleAnimationPose(this.view, now - this.receivedAt)
        if (this.view.performance) {
            // A performance (a wave, a bow) is the body's own business: once a one-off has played,
            // or while the body walks, it gives the sprite back to whatever the body is doing.
            if (sampled.action === "idle" || entity.movement?.moving) return undefined
            return { ...sampled, action: `${sampled.action}-${radians_to_cardinal_dir(this.view.angle)}` }
        }
        const directional = ["walk", "idle", "cast", "slash", "thrust", "shoot"].includes(sampled.action)
        return { ...sampled, action: directional ?
            `${sampled.action}-${radians_to_cardinal_dir(this.view.angle)}` : sampled.action }
    }
}
